import { orthoPagePath } from './orthoMenuPages';

/** Aparatos de ortopedia maxilar (megamenú Ortopedia Maxilar). */
export const MAXILLARY_TREATMENT_ITEMS = [
  { pageId: 'klamm', imageId: 21 },
  { pageId: 'bimler', imageId: 22 },
  { pageId: 'planas', imageId: 23 },
  { pageId: 'stockfisch', imageId: 24 },
  { pageId: 'clarkTwinBlock', imageId: 25 },
];

export function buildMaxillaryMegaMenuLinks() {
  return MAXILLARY_TREATMENT_ITEMS.map(({ pageId }) => ({
    pageId,
    labelKey: `navMega.maxillaryOrtho.${pageId}`,
    descKey: `navMega.maxillaryOrtho.${pageId}Desc`,
    to: orthoPagePath(pageId),
  }));
}
